import { render, staticRenderFns } from "./ProjectPrescriber.vue?vue&type=template&id=1ded695e&scoped=true&"
import script from "./ProjectPrescriber.vue?vue&type=script&lang=js&"
export * from "./ProjectPrescriber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded695e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {VCombobox})
